import { _js } from '@ifixit/utils/localize';
import { DropdownMenuGroup, DropdownMenuSeparator } from '@ifixit/ui/components/dropdown-menu';
import {
   UserMenu,
   UserMenuButton,
   UserMenuContent,
   UserMenuHeading,
   UserMenuLink,
} from '@ifixit/ui/components/user-menu';
import { UserInfoType } from '.';
import Notifications from 'Shared/Notifications/notifications';
import { formatCompact } from 'Shared/utils/numberFormat';
import { facebookLogout } from 'Shared/facebookHelper';

declare global {
   interface Window {
      shared_constants: Record<string, any>;
   }
}

const UserDropdown = ({
   username,
   uniqueUsername,
   profileUrl,
   preferencesUrl,
   ordersUrl,
   reviewsUrl,
   notificationsUrl,
   avatar,
   partner,
   team,
   canIViewManageTab,
   notifications,
}: UserInfoType & { notifications: Notifications }) => {
   const unreadCount = notifications.getUnreadCount();
   const user = {
      username,
      handle: uniqueUsername || null,
      thumbnail: avatar || null,
      partner,
   };

   return (
      <UserMenu user={user}>
         <UserMenuButton aria-label="User Information" avatarId="profileMenuToggle" />
         <UserMenuContent>
            <UserMenuHeading />
            <DropdownMenuSeparator />
            <DropdownMenuGroup id="profileMenu">
               <UserMenuLink
                  href={notificationsUrl}
                  countLabel={unreadCount > 0 ? formatCompact(unreadCount) : undefined}
               >
                  {_js('Notifications')}
               </UserMenuLink>
               <UserMenuLink id="myAccount" href={profileUrl}>
                  {_js('View Profile')}
               </UserMenuLink>
               <UserMenuLink id="preferences" href={preferencesUrl}>
                  {_js('Preferences')}
               </UserMenuLink>
               {team && (
                  <UserMenuLink href={team.teamLink}>
                     {team.teamCount > 1 ? _js('My Teams') : _js('My Team')}
                  </UserMenuLink>
               )}
               <UserMenuLink href={ordersUrl}>{_js('Orders')}</UserMenuLink>
               <UserMenuLink href={reviewsUrl}>{_js('Product Reviews')}</UserMenuLink>
               {canIViewManageTab && <UserMenuLink href="/Manage">{_js('Manage')}</UserMenuLink>}
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
               <UserMenuLink
                  id="navLogout"
                  href={window.shared_constants.GuideURI('TAG_LOGOUT')}
                  onClick={() => facebookLogout()}
               >
                  {_js('Log Out')}
               </UserMenuLink>
            </DropdownMenuGroup>
         </UserMenuContent>
      </UserMenu>
   );
};

export default UserDropdown;
